// extracted by mini-css-extract-plugin
export default {"paddingVertical":"Tooltips_paddingVertical","premiumRow":"Tooltips_premiumRow","padding":"Tooltips_padding","paddingHorisontal":"Tooltips_paddingHorisontal"};